module.exports = __webpack_public_path__ + "static/media/apple-store.3c958c39.png";